






import { defineComponent } from '@vue/composition-api';
import BaseBanner from './BaseBanner.vue';

export default defineComponent({
	components: { BaseBanner },
	setup() {
		return {};
	},
});
